import ExperimentsLoadingCover from './experimentsLoadingCover'

export default ExperimentsLoadingCover
